export interface Vehicle {
	id: string;
	type: string;
	name: string;
	registrationNumber: string;
	inspection: string;
	insurance: string;
	tachographLegalization: string;
	mileage: number;
	lastOilChange: number;
	oilChangeFrequency: number;
	alerts: string;
	lastFiltersChange: number;
	tiresType: string;
	seats: number;
	status: number;
	nawigatorId: number;
	busType: string;
	premium: boolean;
	vinNumber: string;
	vehicleMark: string;
	vehicleModel: string;
	yearOfProduction: number;
	confirmed: Array<any>;
	lastLocation: lastLocation;
	wrappingType: number;
	documents: Documents;
}

export interface lastLocation {
	odometer: number;
	coordinate: string;
	description: string;
}

export interface Documents {
	license: Document;
	autocasco: Document;
	registrationcard: Document;
	autocassco: Document;
	authtouse: Document;
	greencard: Document;
	insurance: Document;
	exhaustStandards: Document;
	certificate100km: Document;
	inspection: Document;
	stAt: Document;
	stBe: Document;
	stCh: Document;
	stDk: Document;
	stDe: Document;
	stDeinfo: Document;
	stSlo: Document;
	tachographLegalization: Document;
	axis: Document;
	fuelTanks: Document;
	hook: Document;
	backpack: Document;
	interBus: Document;
	greenBook: Document;
	chains: Document;
	workshopBox: Document;
	placeBackpack: Document;
	vignetteHungary: Document;
	toiletStatus: Document;
	isClean: Document;
	vest: Document;
	libra: Document;
	childrensBoard: Document;
	movies: Document;
	headphones: Document;
	busDescription: Document;
	boxPl: Document;
	boxXs: Document;
	boxAt: Document;
	boxSi: Document;
	boxSk: Document;
	boxCz: Document;
	box: Document;
	seatsType: Document;
	distanceSeats: Document;
	distanceHeadrests: Document;
	chaiseLongue: Document;
	sockets: Document;
	usb: Document;
	wifi: Document;
	internet: Document;
	monitors: Document;
	multimediaSystem: Document;
	microphone: Document;
	safe: Document;
	board: Document;
	tachoRolls: Document;
	aidKit: Document;
	fireExtinguisher: Document;
	butterflies: Document;
	pinCards: Document;
	multimediaSystemDescription: Document;
	cafeBar: Document;
}

export interface Document {
	id: string;
	endDate: string;
	type: string;
	checkDocument: boolean;
	company: string;
	standard: string;
	number: number;
	capacity: number;
	checkHook: string;
}

export enum VehicleKind {
	BUS = 'bus',
	DUTY = 'duty',
	LEAD = 'lead',
	TRAILER = 'trailer',
	TIR = 'tir',
	TIR_TRAILER = 'naczepa',
	CAR = 'osobowy',
	FLIX_COACH = 'autokar_flix',
	COACH = 'autokar',
}
